import { render, staticRenderFns } from "./studentFiles.vue?vue&type=template&id=3f0a6c68&scoped=true"
import script from "./studentFiles.vue?vue&type=script&lang=js"
export * from "./studentFiles.vue?vue&type=script&lang=js"
import style0 from "./studentFiles.vue?vue&type=style&index=0&id=3f0a6c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0a6c68",
  null
  
)

export default component.exports